import { v4 as uuidv4 } from 'uuid';

let noCache = uuidv4();
let settingsImportPromise = fetch(
  `./environments/dist/settings.json?noCache=${noCache}`,
);
settingsImportPromise
  .then(async response => {
    let globalSettings = await response.json();
    GlobalSettingsStore.value = globalSettings;
    return import('./angularMain');
  })
  .catch(err => {
    throw err;
  });

export const GlobalSettingsStore: {
  value?: any;
} = {};
